import { render, staticRenderFns } from "./AsideButton.vue?vue&type=template&id=46259ba8&"
import script from "./AsideButton.vue?vue&type=script&lang=js&"
export * from "./AsideButton.vue?vue&type=script&lang=js&"
import style0 from "./AsideButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports